import React from 'react';
import BookmarkArt from './BookmarkArt';

export default function ConfiguredItemArt({ item, view = 'front' }) {
  const choices = Object.fromEntries(
    (item.configuration?.options || []).map((option) => [option.group, option]),
  );
  return (
    <BookmarkArt
      slug={item.slug}
      view={view}
      front={choices.front_fabric}
      middle={choices.front_fabric_middle}
      bottom={choices.front_fabric_bottom}
      back={choices.back_fabric}
      ribbonFabric={choices.ribbon_fabric}
      thread={choices.ribbon}
      label={item.name}
    />
  );
}
